import {
  drawerWidth,
  transition,
  container
} from "assets/jss/material-dashboard-react.js";

import bgImage from "assets/img/background5.jpg";

const appStyle = theme => ({
  wrapperContainer: {
    position: "relative",
    top: 0,
    height: "100vh",
    backgroundImage: "url(" + bgImage + ")",
    backgroundSize: "cover",
    backgroundPosition: "center"
  },
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh"
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch"
  },
  content: {
    marginTop: "70px",
    padding: "0px 15px",
    minHeight: "calc(100vh - 123px)"
  },
  container: {
    marginTop: "70px"
  },
  homecontainer: {
    minHeight: "calc(100vh - 90px)",
    background: "#ffffff",
    border: "1px solid black",
    borderRadius: "3px",
    padding: "20px",
    color: "black",
    fontFamily: "Montserrat",
    margin: "0px 15px 20px 15px"
  },
  headerTitle: {
    textAlign: "center",
    width: "100%",
  },
  headerText: {
    margin: 0,
    fontWeight: "bold",
    fontSize: "22px",
    color: "black",
    fontFamily: "Montserrat",
    [theme.breakpoints.down("sm")]: {
      fontSize: "3vw"
    }
  },
  contentText: {
    width: "100%",
    textAlign: "justify",
    fontSize: "16px",
    fontWeight: "bold"
  },
  signature: {
    textAlign: "center"
  },
  signatureText: {
    margin: 0
  },
  logos: {
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  logo: {
    margin: "15px 10px 0px 10px",
    maxWidth: "100%",
    display: "inline-block",
    textAlign: "center",
    outline: "none",
  }
});

export default appStyle;
